export default "__VITE_ASSET__BIA8mEUj__"